export default __webpack_public_path__ + "static/media/move_up.71b3ab46.svg";